import { useState } from "react";
import { useLocation } from "wouter";
import { calendarReadOnlyStore } from "../../../hooks/useAppState";

export function FullscreenAppPage() {
  const [, navigate] = useLocation();
  const [readOnly, setReadOnly] = useState(true);

  const handleOpen = () => {
    calendarReadOnlyStore.set(readOnly);
    navigate("/calendar/fullscreen");
  };

  return (
    <div className="h-dvh bg-surface flex items-center justify-center p-6">
      <div className="max-w-sm w-full flex flex-col items-center gap-6 text-center">
        <div className="w-16 h-16 rounded-2xl bg-accent/10 flex items-center justify-center">
          <svg viewBox="0 0 24 24" className="w-8 h-8 text-accent" stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </div>

        <div>
          <h1 className="text-xl font-bold text-ink">Palnia Calendrier</h1>
          <p className="text-sm text-ink-muted mt-2 leading-relaxed">
            Installez cette app pour afficher votre emploi du temps en plein écran (vue semaine).
            Idéal pour une tablette ou un écran dédié.
          </p>
        </div>

        <div className="flex flex-col gap-2 w-full text-left">
          <div className="flex items-start gap-3 p-3 bg-surface-alt rounded-lg">
            <span className="text-accent mt-0.5">✓</span>
            <span className="text-sm text-ink">Vue semaine en plein écran</span>
          </div>
          <div className="flex items-start gap-3 p-3 bg-surface-alt rounded-lg">
            <span className="text-accent mt-0.5">✓</span>
            <span className="text-sm text-ink">Rafraîchissement automatique toutes les 15 secondes</span>
          </div>
          <div className="flex items-start gap-3 p-3 bg-surface-alt rounded-lg">
            <span className="text-accent mt-0.5">✓</span>
            <span className="text-sm text-ink">Changement de semaine automatique à minuit</span>
          </div>
        </div>

        <div className="w-full flex items-center justify-between p-3 bg-surface-alt rounded-lg">
          <div className="text-left">
            <span className="text-sm text-ink font-medium">Mode lecture seule</span>
            <p className="text-[10px] text-ink-muted mt-0.5">
              {readOnly ? "Consultation uniquement, pas de modification" : "Vous pourrez modifier les événements"}
            </p>
          </div>
          <button
            type="button"
            onClick={() => setReadOnly((v) => !v)}
            className={`w-10 h-5 rounded-full transition-colors relative shrink-0 ${
              readOnly ? "bg-accent" : "bg-border"
            }`}
          >
            <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform ${
              readOnly ? "left-5" : "left-0.5"
            }`} />
          </button>
        </div>

        <div className="flex flex-col gap-3 w-full">
          <button
            type="button"
            onClick={handleOpen}
            className="w-full px-4 py-3 bg-accent text-white font-semibold rounded-lg hover:bg-accent/90 transition-colors"
          >
            Ouvrir le calendrier
          </button>
          <p className="text-[10px] text-ink-faint leading-relaxed">
            Chrome / Edge : cliquez sur l'icône d'installation dans la barre d'adresse.
            <br />
            iPhone / iPad : Safari → Partager → « Sur l'écran d'accueil ».
            <br />
            Android : menu ⋮ → « Installer l'application ».
          </p>
        </div>
      </div>
    </div>
  );
}
